/* eslint-disable */
import React, { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import BgGradient from '../../../static/images/bggradient.webp'
import { ServiceCard } from './components/ServiceCard'
import FeedbackSection from '../components/feedback'
import {Service1Icon, Service2Icon, Service4Icon, Service5Icon, Service6Icon, Service7Icon, Service8Icon, Service3Icon} from '../../../components/svgs/Svgs'

export function Services() {
    const location = useLocation()
    const { t } = useTranslation()
    const navigate = useNavigate()

    useEffect(() => {
        document.documentElement.style.scrollBehavior = 'smooth'
        window.scrollTo({ top: 0, behavior: 'smooth' })
    }, [location])

    const serviceData = [
        {
            id: 1,
            title: t('landing.services.cards.agent.title'),
            text: t('landing.services.cards.agent.text'),
            icon: Service1Icon,
        },
        {
            id: 2,
            title: t('landing.services.cards.machine.title'),
            text: t('landing.services.cards.machine.text'),
            icon: Service2Icon,
        },
        {
            id: 3,
            title: t('landing.services.cards.llm.title'),
            text: t('landing.services.cards.llm.text'),
            icon: Service3Icon,
        },
        {
            id: 4,
            title: t('landing.services.cards.aiagent.title'),
            text: t('landing.services.cards.aiagent.text'),
            icon: Service4Icon,
        },
        {
            id: 5,
            title: t('landing.services.cards.satellite.title'),
            text: t('landing.services.cards.satellite.text'),
            icon: Service5Icon,
        },
        {
            id: 6,
            title: t('landing.services.cards.labeling.title'),
            text: t('landing.services.cards.labeling.text'),
            icon: Service6Icon,
        },
        {
            id: 7,
            title: t('landing.services.cards.aiendge.title'),
            text: t('landing.services.cards.aiendge.text'),
            icon: Service7Icon,
        },
        {
            id: 8,
            title: t('landing.services.cards.federate.title'),
            text: t('landing.services.cards.federate.text'),
            icon: Service8Icon,
        },
    ]
    return (
        <>
            <div className="w-full flex flex-col lg:max-w-[1440px]
            pb-[24px] lg:m-auto px-[24px] lg:px-[20px] gap-[100px]"
            >
                <section style={{ backgroundImage: `url(${BgGradient})` }}>
                    <div className="flex flex-col pt-[38px] pb-[20px] items-center gap-[15px]">
                        <span className="text-[28px] font-[300] text-[#262626] dark:text-white">
                            {t('landing.services.title')}
                        </span>
                        <div className="flex items-center">
                            <span
                                onClick={() => navigate('/')}
                                className="text-[14px] cursor-pointer font-[300] dark:text-white text-[#262626]"
                            >
                                {t('landing.services.breadcrumb.home')}
                                /
                            </span>
                            <span className="text-[14px] cursor-pointer font-normal dark:text-white text-[#262626]">
                                {t('landing.services.breadcrumb.current')}
                            </span>
                        </div>
                    </div>
                </section>
                <section>
                    <div className="flex flex-col lg:px-[24px] items-start mb-[91px] gap-[10px]">
                        <span className="text-[12px] lg:text-[16px] font-normal text-[#0068B5] dark:text-white">
                            {t('landing.services.stats.cardTitle')}
                        </span>
                        <span className="text-[31px] font-[300] text-[#262626] dark:text-white">
                            {t('landing.services.stats.cardSubTitle')}
                        </span>
                    </div>
                    <div className="grid md:grid-cols-2 sm:grid-cols-1 lg:grid-cols-3
                lg:px-[24px] sm:gap-[60px] lg:gap-[70px]"
                    >
                        {serviceData?.map((item) => (
                            <ServiceCard key={item.id} icon={item.icon} title={item.title} text={item.text} />
                        ))}
                    </div>
                </section>
            </div>
            <div className="w-[100%] mt-[20px]">
                <FeedbackSection />
            </div>
        </>
    )
}
